export function isAppActive(): boolean {
    return document.visibilityState === 'visible' && document.hasFocus()
}

// pause when tab is hidden, window loses focus, or page is frozen
export function subscribeToAppBackground(onBackground: () => void): () => void {
    const onVisibilityHidden = () => {
        if (document.visibilityState === 'hidden') {
            onBackground()
        }
    }

    document.addEventListener('visibilitychange', onVisibilityHidden)
    window.addEventListener('blur', onBackground)
    document.addEventListener('freeze', onBackground)

    return () => {
        document.removeEventListener('visibilitychange', onVisibilityHidden)
        window.removeEventListener('blur', onBackground)
        document.removeEventListener('freeze', onBackground)
    }
}
